import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  button: {
    padding: theme.spacing(0.5, 2),
  },
}));
